(function () {
  var nodes = document.querySelectorAll('.stoney-reveal');
  if (!nodes.length) return;

  function revealAll() {
    nodes.forEach(function (n) {
      n.classList.add('stoney-reveal--in');
    });
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    revealAll();
    return;
  }

  if (!('IntersectionObserver' in window)) {
    revealAll();
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('stoney-reveal--in');
          io.unobserve(e.target);
        }
      });
    },
    { rootMargin: '0px 0px -5% 0px', threshold: 0.05 }
  );
  nodes.forEach(function (n) {
    io.observe(n);
  });
})();
